import React, { useMemo, useContext, useEffect, useState } from 'react'
import { Table, Icon, Checkbox, Popup } from 'semantic-ui-react'
// import { DatePicker } from '../../../components/shared/DatePicker'
import RoomsDropDown from '../../../components/shared/RoomsDropDown';
import GuestSearchDropDown from '../../../components/shared/GuestSearchDropDown'
import moment from 'moment'
import { GroupReservationContext, actions } from '../context'
import PropTypes from 'prop-types'
import { Currencies } from '../../../components/shared/currencies';
import CurrencyInput from '../../../components/shared/CurrencyInput';
import _ from 'lodash'
import { CalculateTotalAmountCurrentReservation } from '../../../api/services/pms';
import { Products } from '../../../api/services/next';
import NumericInput from '../../../components/shared/NumericInput';
import { endpoint } from '../../../api/http';
import { resStates, getMainBlock } from '../consts';
import { dateFormatSpaces } from '../../../components/shared/constants';
import { onWarning } from '../../../components/shared/messages';
import { useMessageResources } from '../../../language';

const FitReservation = ({ fit, filter, onSelectRoom, errors, rowKey, onUpdate, ignoreRestrictions = true }) => {
    const { state, dispatch } = onUpdate ? { dispatch: onUpdate, state: {} } : useContext(GroupReservationContext)
    const [reservation, setReservation] = useState(fit.Reservation)
    const [loading, setLoading] = useState(false)
    const message = useMessageResources()

    useEffect(() => {
        if (reservation.ReservationPricingTypeID == 1 && fit.State === resStates.new) {
            (async () => {
                setLoading(true);
                const ProductsSpec = {
                    HotelId: reservation.HotelId,
                    RoomTypeId: reservation.RoomTypeId,
                    FromDate: moment(reservation.CheckInDate).startOf('day').toISOString(),
                    ToDate: moment(reservation.CheckOutDate).startOf('day').toISOString(),
                    "Pax.Adults": reservation.Adults,
                    "Pax.Children": reservation.Children,
                    "Pax.Infants": reservation.Infants,
                    GetPricingForLastDateOfRange: moment(reservation.CheckInDate).startOf('day').isSame(moment(reservation.CheckOutDate).startOf('day')) ? true : false,
                    IgnoreRestrictions: ignoreRestrictions,
                    Id: reservation.ProductID,
                    Includes: ["ProductPrices",
                        "DailyProductPrices",
                        "Restrictions",
                        "Rate"]
                };
                const products = await Products.Search(ProductsSpec);

                if (products.length === 0)
                    onWarning(message('ProductNotAvailable'))

                /*eslint-disable */

                reservation.TotalAmountProductCurrentBeforeTax = products[0]?.TotalPriceBeforeTax;
                reservation.TotalAmountProductCurrentAfterTax = products[0]?.TotalPriceAfterTax;
                reservation.RateName = products[0]?.RateName;
                if (reservation.IsOverriddenTotalAmountAfterTax) {
                    reservation.OverriddenTotalAmount = products[0]?.TotalPriceAfterTax;
                    reservation.IsOverriddenTotalAmountAfterTax = true;
                }
                else {
                    reservation.OverriddenTotalAmount = products[0]?.TotalAmountBeforeTax;
                    reservation.IsOverriddenTotalAmountAfterTax = false;
                }
                reservation.OverrideProductPrice = true;
                reservation.ReservationPricingTypeID = 1;
                /*eslint-enable */
                dispatch(actions.update)
                setLoading(false)
            })()
        }
    }, [reservation.Adults, reservation.Children, reservation.Infants])

    useEffect(() => {
        setReservation(fit.Reservation);
    }, [fit.Reservation]);

    const setGuest = value => {
        if (reservation.GuestId === value) {
            return;
        }

        reservation.GuestId = value
        //dont clear guest if its new guest
        if (!(typeof value === "string" && value.startsWith("newguest"))) {
            reservation.Guest = null
        }
        fit.State = resStates.new
        dispatch({ type: actions.update })
    }
    const addGuest = guest => {
        const mainReservation = getMainBlock(state.ReservationGroup.ReservationGroupReservations)
        const mainGuest = mainReservation.Reservation.Guest
        if (mainGuest) {
            guest.NationalityID = mainGuest.NationalityID
            guest.LanguageID = mainGuest.LanguageID
        }
        reservation.GuestId = guest.Id
        reservation.Guest = guest
        fit.State = resStates.new
        dispatch({ type: actions.update })
    }
    const setAdults = value => {
        reservation.Adults = Number(value)
        fit.State = resStates.new
        dispatch({ type: actions.update })
    }
    const setChildren = value => {
        reservation.Children = Number(value)
        fit.State = resStates.new
        dispatch({ type: actions.update })
    }
    const setInfants = value => {
        reservation.Infants = Number(value)
        fit.State = resStates.new
        dispatch({ type: actions.update })
    }
    const setRoom = value => {
        if (value) {
            if (reservation.Room && reservation.Room.Id === value.Id) return;
            reservation.RoomId = value.Id
            reservation.Room = value
        } else {
            reservation.RoomId = null
            reservation.Room = null
        }

        if (onSelectRoom) {
            onSelectRoom(reservation, value?.Id, rowKey)
        }

        fit.State = resStates.new
        dispatch({ type: actions.update })
    }
    const calc = useMemo(() => _.debounce(async (reservation) => {
        const updated = await CalculateTotalAmountCurrentReservation({
            Reservation: reservation,
            IsReCalculateTax: true,
            IncludeCommissionCalculation: reservation.Id ? true : false,
            DigitsPercision: 8
        })
        /*eslint-disable */
        if (reservation.IsOverriddenTotalAmountAfterTax) {
            reservation.TotalAmountProductCurrentBeforeTax = updated.TotalAmountProductCurrentBeforeTax
        } else {
            reservation.TotalAmountProductCurrentAfterTax = updated.TotalAmountProductCurrentAfterTax
        }
        /*eslint-enable */
        dispatch({ type: actions.update });
    }, 500), [])

    const setAmountBeforeTax = value => {
        reservation.TotalAmountProductCurrentBeforeTax = value
        reservation.OverriddenTotalAmount = value
        reservation.IsOverriddenTotalAmountAfterTax = false
        reservation.OverrideProductPrice = true;
        reservation.ReservationPricingTypeID = 2;
        fit.State = resStates.new
        calc(reservation)
    }

    const setAmountAfterTax = value => {
        reservation.TotalAmountProductCurrentAfterTax = value
        reservation.OverriddenTotalAmount = value
        reservation.IsOverriddenTotalAmountAfterTax = true
        reservation.OverrideProductPrice = true;
        reservation.ReservationPricingTypeID = 2;
        fit.State = resStates.new
        calc(reservation)
    }

    const RoomsSpec = useMemo(() => {
        return {
            HotelID: reservation.HotelId,
            RoomTypeIDs: reservation.RoomTypeId,
            FromAdultsMaxPax: reservation.Adults,
            FromChildrenMaxPax: reservation.Children,
            FromInfantsMaxPax: reservation.Infants,
            AvailableFrom: reservation.CheckInDate,
            AvailableTo: reservation.CheckOutDate
        }
    }, [reservation.Adults, reservation.Children, reservation.Infants, reservation.CheckInDate, reservation.CheckOutDate])

    const onSelectReservation = (e, { checked }) => {
        fit.IsSelected = checked
        dispatch({ type: actions.update })
    }
    const currency = Currencies[reservation.CurrencyId]
    const symbol = currency ? currency.symbol : null
    return (
        <Table.Row key={reservation.Id}>
            <Table.Cell>
                <Checkbox onChange={onSelectReservation} checked={fit.IsSelected} />
            </Table.Cell>
            <Table.Cell width="1">
                <a rel="noopener noreferrer" href={`${endpoint}PMS/Reservations/Index/${reservation.Id}`} target="_blank">
                    {reservation.Number}
                </a>
            </Table.Cell>
            <Table.Cell width="2">
                {moment(reservation.CheckInDate).format(dateFormatSpaces) + ' - ' + moment(reservation.CheckOutDate).format(dateFormatSpaces)}
            </Table.Cell>
            <Table.Cell width="2">
                <GuestSearchDropDown error={errors ? errors["Guest"] : null} fluid popup={false} placeholder="Full Name" guest={reservation.Guest} value={reservation.GuestId} onChange={setGuest} onAddGuest={addGuest} />
            </Table.Cell>
            <Table.Cell width="1">
                <NumericInput error={errors ? errors["PAX"] : null} className="numeric" fluid digits={0} placeholder="Adults" value={String(reservation.Adults)} buttonPlacement="right" onChange={setAdults} />
            </Table.Cell>
            <Table.Cell width="1">
                <NumericInput error={errors ? errors["PAX"] : null} className="numeric" fluid digits={0} placeholder="Children" value={String(reservation.Children)} buttonPlacement="right" onChange={setChildren} />
            </Table.Cell>
            <Table.Cell width="1">
                <NumericInput className="numeric" fluid digits={0} placeholder="Infants" value={String(reservation.Infants)} buttonPlacement="right" onChange={setInfants} />
            </Table.Cell>
            <Table.Cell width="2">
                {reservation.RoomTypeName || reservation.RoomType?.Name}
            </Table.Cell>
            <Table.Cell width="1">
                {reservation.RateName || ''}
            </Table.Cell>
            <Table.Cell width="2">
                <RoomsDropDown spec={RoomsSpec} filter={(rooms, value) => filter(rooms, value, reservation)} clearable fluid placeholder="Room" value={reservation.RoomId} onChangeItem={setRoom} initial={reservation.Room} />
            </Table.Cell>
            <Table.Cell width="2">
                <CurrencyInput loading={loading} size="small" currency={symbol} fluid placeholder="Price Not Inc. TAX" value={reservation.TotalAmountProductCurrentBeforeTax} onChange={setAmountBeforeTax} />
            </Table.Cell>
            <Table.Cell width="2">
                <CurrencyInput loading={loading} size="small" currency={symbol} fluid placeholder="Price Inc. TAX" value={reservation.TotalAmountProductCurrentAfterTax} onChange={setAmountAfterTax} />
            </Table.Cell>
            <Table.Cell textAlign="center">
                {(fit.State && fit.Error) ?
                    <Popup hoverable trigger={<Icon name={fit.State.icon} size="large" />} content={fit.Error.error.ErrorMessage} position="left center" /> :
                    <Icon name={fit.State ? fit.State.icon : "save outline"} loading={fit.State === resStates.saving} size="large" />
                }
            </Table.Cell>
        </Table.Row>
    )
}

FitReservation.propTypes = {
    fit: PropTypes.any,
    filter: PropTypes.any,
    onSelectRoom: PropTypes.func,
    errors: PropTypes.any,
    rowKey: PropTypes.any,
    onUpdate: PropTypes.func
}
export default FitReservation
